import { useEffect } from "react";
import { Carrousel, Cards, Collaborators } from "./components";

type MailerLiteClient = {
  (command: string, accountId: string): void;
  q: [string, string][];
};

export default function Home() {
  useEffect(() => {
    const mailerLiteWindow = window as Window & { ml?: MailerLiteClient };
    const queue: [string, string][] = [];
    const mailerLite = mailerLiteWindow.ml ?? Object.assign(
      (command: string, accountId: string) => queue.push([command, accountId]),
      { q: queue },
    );
    const script = document.createElement("script");

    mailerLiteWindow.ml = mailerLite;
    mailerLite("account", "2746304");
    script.id = "mailerlite-universal";
    script.src = "https://assets.mailerlite.com/js/universal.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      script.remove();
      if (mailerLiteWindow.ml === mailerLite) {
        Reflect.deleteProperty(mailerLiteWindow, "ml");
      }
    };
  }, []);

  return (
    <>
      <Carrousel />
      <Cards />
      <Collaborators />
    </>
  );
}
